export const frReminders = {
    'reminder.name': 'Rappel',

    // REMINDERS

    'reminders.create.pageTitle': 'Créer un rappel',
    'reminders.create.actions.cancelCreation': 'Annuler la création',
    'reminders.create.actions.addTheReminder': 'Enregistrer',
    'reminders.create.input.name': 'Saisissez ici le nom du rappel *',
    'reminders.create.input.code': 'Saisissez ici le code du rappel',
    'reminders.create.input.floatingLabelName': 'Nom',
    'reminders.create.input.floatingLabelCode': 'Code',
    'reminders.create.tabs.info': 'Informations',
    'reminders.create.tabs.questions': 'Questions',
    'reminders.create.tabs.audience': 'Audience',
    'reminders.create.tabs.notifications': 'Notifications',
    'reminders.create.tabs.audiences.treeTitle': 'Choix sectorisation',
    'reminders.create.tabs.informations.generalSectionTitle': 'Informations générales',
    'reminders.create.tabs.informations.publishSectionTitle': 'Publication',
    'reminders.create.tabs.informations.inputs.floatingLabelEndDate': "Date d'échéance",
    'reminders.create.tabs.informations.inputs.endDate': "Sélectionnez une date d'échéance",
    'reminders.create.tabs.informations.inputs.description':
        'Saisissez ici la description du rappel',
    'reminders.create.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'reminders.create.tabs.informations.inputs.questionCode':
        'Saisissez ici un code dédidé à cette question',
    'reminders.create.tabs.informations.inputs.floatingLabelQuestionCode': 'Code question',
    'reminders.create.tabs.informations.questions.title': 'Titre',
    'reminders.create.tabs.informations.questions.titleHintText': 'Saisir ici un titre',
    'reminders.create.tabs.informations.questions.description': 'Description',
    'reminders.create.tabs.informations.questions.descriptionHintText':
        'Saisir ici une description',
    'reminders.create.tabs.informations.questions.externalReference': 'Ref. externe',
    'reminders.create.tabs.informations.questions.externalReferenceHintText':
        'Saisir ici la référence',
    'reminders.create.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'reminders.create.tabs.informations.select.owner.title': 'Sélectionnez le propriètre du rappel',
    'reminders.create.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'reminders.create.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'reminders.create.tabs.informations.select.owner.listInputLabel':
        'Chercher un utilisateur siège',
    'reminders.create.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'reminders.create.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'reminders.create.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'reminders.create.tabs.informations.select.docs.title': 'Joindre un fichier PDF',
    'reminders.create.tabs.informations.select.docs.label': 'Fichier PDF',
    'reminders.create.tabs.informations.select.docs.btn': 'Parcourir',
    'reminders.create.tabs.informations.select.docs.imageUrl': "URL de l'image",
    'reminders.create.tabs.informations.select.docs.load': 'Charger',
    'reminders.create.tabs.informations.select.docs.hintHttp': 'http://...',
    'reminders.create.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'reminders.create.tabs.informations.publish.publishBtn': 'Publier',
    'reminders.create.tabs.informations.publish.cancelBtn': 'Annuler la publication',

    // REMINDERS >> DETAILS

    'reminders.details.pageTitle': 'Détails rappel',
    'reminders.details.actions.previous': 'Évènements',

    'reminders.details.actions.save': 'Enregistrer',
    'reminders.details.actions.remove': 'Supprimer',
    'reminders.details.input.name': 'Saisissez ici le nom du rappel *',
    'reminders.details.input.code': 'Saisissez ici le code du rappel',
    'reminders.details.input.floatingLabelName': 'Nom',
    'reminders.details.input.floatingLabelCode': 'Code',
    'reminders.details.dialog.title': 'Suppression du rappel',
    'reminders.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce rappel ?',
    'reminders.details.dialog.validateLabel': 'Supprimer',
    'reminders.details.dialog.cancelLabel': 'Annuler',
    'reminders.details.tabs.info': 'Informations',
    'reminders.details.tabs.audience': 'Audience',
    'reminders.details.tabs.informations.generalSectionTitle': 'Informations générales',
    'reminders.details.tabs.informations.publishSectionTitle': 'Publication',
    'reminders.details.tabs.informations.inputs.description':
        'Saisissez ici la description du rappel',
    'reminders.details.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'reminders.details.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'reminders.details.tabs.informations.select.owner.title':
        'Sélectionnez le propriètre du rappel',
    'reminders.details.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'reminders.details.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'reminders.details.tabs.informations.select.owner.listInputLabel':
        'Chercher un utilisateur siège',
    'reminders.details.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'reminders.details.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'reminders.details.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'reminders.details.tabs.informations.select.docs.title': 'Joindre un fichier PDF',
    'reminders.details.tabs.informations.select.docs.label': 'Fichier PDF',
    'reminders.details.tabs.informations.select.docs.btn': 'Parcourir',
    'reminders.details.tabs.informations.select.docs.imageUrl': "URL de l'image",
    'reminders.details.tabs.informations.select.docs.load': 'Charger',
    'reminders.details.tabs.informations.select.docs.hintHttp': 'http://...',
    'reminders.details.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'reminders.details.tabs.informations.select.publisher.sectionTitle': 'Publier en tant que',
    'reminders.details.tabs.informations.select.publisher.title': 'Sélectionnez le nom du publieur',
    'reminders.details.tabs.informations.select.publisher.floatingLabelTitle':
        'Publier en tant que',
    'reminders.details.tabs.informations.select.publisher.listTitle': 'Choix du publieur',
    'reminders.details.tabs.informations.select.publisher.listInputLabel':
        'Chercher un utilisateur ou une équipe',
    'reminders.details.tabs.informations.select.publisher.listCloseLabel': 'Fermer',
    'reminders.details.tabs.informations.publish.publishBtn': 'Publier',
    'reminders.details.tabs.informations.publish.cancelBtn': 'Annuler la publication',

    // TOAST ERRORS
    'toast.apiErrors.REMINDER_CANT_DELETE_PUBLISHED':
        'Impossible de supprimer un rappel qui a été publié',
    'toast.apiErrors.REMINDER_ALREADY_PUBLISHED': 'Ce rappel est déjà publié',
    'toast.apiErrors.REMINDER_MISSING_AUDIENCE':
        "Aucune audience n'est définie pour ce rappel, il ne peut pas être publié",
    'toast.apiErrors.REMINDER_ALREADY_UNPUBLISHED':
        'Ce rappel est déjà au statut publication annulée',
    'toast.apiErrors.REMINDER_EDIT_DATES_PUBLISHED':
        'Ce rappel est publié, les dates ne sont plus modifiables',
    'toast.apiErrors.REMINDER_EDIT_ADDRESS_PUBLISHED':
        "Ce rappel est publié, l'adresse n'est plus modifiable",
    'toast.apiErrors.REMINDER_MUST_HAVE_DATES':
        "La date de début et la date d'échéance doivent être définies",
};
